export const SET_VATRATES = 'vatRatesDB:set';
